import React, { Fragment, useEffect, useState } from "react";
import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { routes } from "./Routes";
import Layout from "../Layout/Layout";
import NotFound from "../Pages/NotFound";
import ProtectedRoute from "./ProtectedRoute";
import { SelectedCenterProvider } from "../Pages/CenterContext";
import { SelectedOrganizationProvider } from "../Pages/OrganizationContext";
import { getLocalItem, checkStatusCodeSuccess } from "../Constant/common";
import { getOnboardingStatusApi } from "../Api/OrganizationApi";

// ── Onboarding guard: redirects to /onboarding when onboarding is not complete ────────
const OnboardingGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    // Skip check if already on onboarding page
    if (location.pathname === "/onboarding") {
      setChecked(true);
      return;
    }

    const role = getLocalItem("role");
    // Only run for Admin roles (e.g. Admin, Admin Los Pollas)
    if (!role || !role.startsWith("Admin")) {
      setChecked(true);
      return;
    }

    const organizationId = getLocalItem("organizationId");
    if (!organizationId) {
      setChecked(true);
      return;
    }

    getOnboardingStatusApi(organizationId)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          const onboarding = resp?.data;
          if (onboarding && !onboarding.completed) {
            navigate("/onboarding", { replace: true });
          }
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error("Failed to check onboarding status:", err);
      })
      .finally(() => setChecked(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) return null;
  return children;
};

const LayoutRoutes = () => {
  const permissions = JSON.parse(getLocalItem("permissions")) || [];

  return (
    <Fragment>
      <SelectedCenterProvider>
        <SelectedOrganizationProvider>
          <OnboardingGuard>
            <Routes>
              {routes?.map(({ path, Component }, i) => (
                <Route element={<Layout />} key={i}>
                  <Route
                    path={path}
                    element={
                      <ProtectedRoute
                        path={path}
                        element={Component}
                        permissions={permissions}
                        routes={routes}
                      />
                    }
                  />
                </Route>
              ))}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </OnboardingGuard>
        </SelectedOrganizationProvider>
      </SelectedCenterProvider>
    </Fragment>
  );
};

export default LayoutRoutes;
